<template>
  <section class="product">
    <h2 class="title">智慧能源管控平台</h2>
    <div class="bar">
      <div class="circular"></div>
    </div>
    <p class="subheading">利用移动互联网、人工智能、自动化控制、物联网等现代信息技术，对电力设备进行7*24小时的自动化数据采集与数据分析，加强电力系统的实时监测和故障诊断</p>
    <div class="solution">
      <div class="solution-content">
        <div class="first">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="flaticon-software" name="cubes" />
            </div>
            <h3 class="subtitle">平台概述</h3>
            <p class="detailed">
              实现企业电力调度、
              <span class="block-level">电力监控、设备管理、电力运维</span>
              等一体化管控
            </p>
            <!-- <a class="link">
              <v-icon class="more" name="arrow-right" />
            </a> -->
          </div>
        </div>
      </div>
      <div class="solution-content">
        <div class="second">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="flaticon-software" name="desktop" />
            </div>
            <h3 class="subtitle">应用领域</h3>
            <p class="detailed">
              适用于港口、机场、工厂、
              <span class="block-level">园区、新能源</span>
              应用等大型用电企业
            </p>
            <!-- <a class="link">
              <v-icon class="more" name="arrow-right" />
            </a> -->
          </div>
        </div>
      </div>
      <div class="solution-content">
        <div class="third">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="flaticon-software" name="university" />
            </div>
            <h3 class="subtitle">系统构成</h3>
            <p class="detailed">
              基础软件和一部分应用软件
              <span class="block-level">在电力运维领域内</span>
              具有一定的功能通用性
            </p>
            <!-- <a class="link">
              <v-icon class="more" name="arrow-right" />
            </a> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "product"
}
</script>

<style lang="scss" scoped>
@mixin hover-bg-img {
  background-position: center;
  // background-size: calc(100% - 2px) calc(100% - 2px);
  background-size: cover;
  background-repeat: no-repeat;
}

.product {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  height: 587px;

  @media (max-width: 260px) {
    height: 100%;
    .grid-content {
      width: 219px;
    }

    .solution-content {
      padding: 0px;
    }
  }

  @media (max-width: 576px) {
    max-width: 540px;
    padding-right: 0px;
    padding-left: 0px;
    margin-top: 70px;

    .subheading {
      padding: 0 15px;
    }

    .first {
      @include hover-bg-img;
      background-image: url("../../assets/img/1.jpg");
    }

    .second {
      @include hover-bg-img;
      background-image: url("../../assets/img/2.jpg");
    }

    .third {
      @include hover-bg-img;
      background-image: url("../../assets/img/3.jpg");
    }

    .grid-content {
      color: #ffffff;
      background-image: linear-gradient(
        to bottom right,
        rgb(251, 117, 104, 0.6) 9%,
        rgba(231, 140, 81, 0.8) 40%,
        rgba(249, 169, 87, 0.9) 100%
      );

      .flaticon-software {
        color: #ffffff;
      }

      .detailed {
        color: #ffffff;
      }

      .more {
        color: #e36cd9;
      }
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }
  
  @media (max-width: 768px) {
    height: 100%;

    .solution {
      display: inline;
    } 
  }

  @media (min-width: 768px) {
    max-width: 740px;
  }

  @media (min-width: 769px) and (max-width: 991px) {
      .grid-content{
        .detailed{
          .distraction{
            line-height: 52px;
          }
        }
      } 
    }
  @media (max-width: 992px) {
    .grid-content{
      .detailed{
         .block-level{
          display: inline;
        }
      }
    } 
  }

  @media (min-width: 992px) {
    max-width: 880px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }
}

.title {
  font-size: 22px;
  margin: 0;
}

.bar {
  height: 4px;
  width: 90px;
  background: #ffe1fd;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular {
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #e36cd9;
    animation: mymove 4s infinite;
    -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/
    
    @keyframes mymove {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
    
    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  font-size: 14px;
  max-width: 520px;
  margin: 0 auto;
  margin-bottom: 50px;
  color: #6084a4;
  line-height: 1.9;
}

.solution {
  display: flex;
  margin-bottom: 40px;
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.first {
  &:hover {
    @include hover-bg-img;
    background-image: url("../../assets/img/1.jpg");
  }
}

.second {
  &:hover {
    @include hover-bg-img;
    background-image: url("../../assets/img/2.jpg");
  }
}

.third {
  &:hover {
    @include hover-bg-img;
    background-image: url("../../assets/img/3.jpg");
  }
}

.grid-content {
  position: relative;
  padding: 40px 30px;
  text-align: center;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px dashed #cdf1d8;
  margin-bottom: 30px;

  .subtitle {
    font-size: 16px;
    transition: 0.5s;
    margin-top: 20px;
    margin-bottom: 17px;
    line-height: 1.4;
    z-index: 999;
  }

  .detailed {
    margin-top: 0;
    margin-bottom: 20px;
    transition: 0.9s;
    color: #6084a4;
    line-height: 1.9;
    font-size: 14px;
    .block-level{
      display: block;
    }
  }

  .link {
    display: block;
    margin: 0 auto;
    width: 35px;
    height: 35px;
    line-height: 35px;
    color: #0e314c;
    background-color: #f9fafb;
    border-radius: 50%;
    cursor: pointer;
    .more {
      width: 10px;
      height: 35px;
    }
  }

  &:hover {
    color: #ffffff;
    background-image: linear-gradient(
      to bottom right,
      rgb(251, 117, 104, 0.6) 9%,
      rgba(231, 140, 81, 0.8) 40%,
      rgba(249, 169, 87, 0.9) 100%
    );

    .flaticon-software {
      color: #ffffff;
    }

    .detailed {
      color: #ffffff;
    }

    .more {
      color: #e36cd9;
    }
  }
}

.icon {
  display: inline-block;
  width: 70px;
  height: 70px;
  line-height: 86px;
  border: 1px solid #e3f7e9;
  border-radius: 50%;
  
  .flaticon-software {
    color: #e36cd9;
    width: 30px;
    height: 30px;
  }
}
</style>